/* eslint-disable import/no-default-export */
import React from 'react';

const SubscribeIcon = (props) => (
  <svg width={12} height={8} viewBox="0 0 12 8" {...props}>
    <g fill={props.color || 'currentColor'} fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M2.412 4.135c.98.845 2.104 1.473 3.595 1.473 1.465 0 2.702-.639 3.62-1.507.212-.2.401-.411.567-.624-.167-.2-.356-.4-.567-.59-.942-.842-2.131-1.29-3.627-1.29-1.482 0-2.653.468-3.597 1.35a5.763 5.763 0 0 0-.57.616c.172.195.365.388.58.573zM0 3.609S1.71.019 6 .019s6 3.43 6 3.43-1.742 3.752-6 3.752-6-3.592-6-3.592z"
      />
      <ellipse cx={6} cy={3.623} rx={1.5} ry={1.543} />
    </g>
  </svg>
);

export default SubscribeIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/SubscribeIcon.js